import { PushKey, PushValue, GA4EventBase, GA4BaseContext } from '../types';
import { getSessionId } from '../../../helpers';

export function compact<T extends Record<string, unknown>>(obj: T) {
  const out: Record<string, unknown> = {};
  Object.entries(obj).forEach(([k, v]) => {
    const isEmptyArray = Array.isArray(v) && v.length === 0;
    if (v !== undefined && v !== null && v !== '' && !isEmptyArray) {
      out[k] = v;
    }
  });
  return out;
}

export function pushLegacyUAEventToDataLayer(
  key: PushKey,
  value: PushValue,
): void {
  window.dataLayer ??= [];

  const data: Record<string, any> = {};

  if (Array.isArray(key)) {
    key.forEach((name, i) => {
      data[name] = Array.isArray(value) ? value[i] : undefined;
    });
  } else {
    data[key] = value;
  }

  window.dataLayer.push(data);
}

export function pushGA4Event(eventData: GA4EventBase): void {
  window.dataLayer ??= [];

  window.dataLayer.push({
    ...eventData,
    session_id: getSessionId(),
    page_title: document.title,
  });
}

export function initGA4Context(contextData: GA4BaseContext): void {
  window.dataLayer ??= [];

  window.dataLayer.push(contextData);
}

export function getCookieValue(name: string): string | undefined {
  const cookies = document.cookie.split(';').map((cookie) => cookie.trim());
  for (const cookie of cookies) {
    if (cookie.startsWith(`${name}=`)) {
      return cookie.substring(name.length + 1);
    }
  }
  return undefined;
}

export function formatEventLabel(
  template: string,
  replacements: Record<string, string>,
) {
  return Object.entries(replacements).reduce((result, [key, val]) => {
    return result.replace(new RegExp(`{{${key}}}`, 'g'), val);
  }, template);
}
